import React from 'react';
import PropTypes from 'prop-types';

let alertsIntensityTypes = [];
let alertsOtherTypes = [];
let alertsIndicatorTypes = [];
const intensityLevels = ['A', 'B', 'C'];

class AlertsLegend extends React.Component {

    componentWillMount() {
        alertsIntensityTypes = [
            {
                lable: this.context.t('open'),
                class: 'open',
            },
            {
                lable: this.context.t('close'),
                class: 'close-group',
            },
        ];

        alertsOtherTypes = [
            {
                lable: this.context.t('interference_artifact'),
                class: 'artifact',
            },
            {
                lable: this.context.t('shadow'),
                class: 'shadow',
            },
            {
                lable: this.context.t('false_path'),
                class: 'false-path',
            },
            {
                lable: this.context.t('consumption'),
                class: 'irrigation',
            },
        ];

        alertsIndicatorTypes = [
            {
                lable: this.context.t('located'),
                class: 'located',
            },
            {
                lable: this.context.t('event_maybe_over'),
                class: 'event-maybe-over',
            },
        ];
    }

    render() {
        const p = this.props;
        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            {
                                intensityLevels && intensityLevels.map((title, index) => {
                                    return (
                                        <th>{title}</th>
                                    );
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            alertsIntensityTypes && alertsIntensityTypes.map((type, index) => {
                                return (
                                    <tr className="table-row">
                                        <th>{type.lable}</th>
                                        <td className={'alert ' + type.class + ' a'} ></td>
                                        <td className={'alert ' + type.class + ' b'} ></td>
                                        <td className={'alert ' + type.class + ' c'} ></td>
                                    </tr>
                                );
                            })

                        }

                        {
                            alertsOtherTypes && alertsOtherTypes.map((otherType, otherIndex) => {
                                return (
                                    <tr className="table-row">
                                        <th>{otherType.lable}</th>
                                        <td className={'alert ' + otherType.class} ></td>
                                    </tr>
                                );
                            })
                        }

                        {
                            alertsIndicatorTypes && alertsIndicatorTypes.map((indicatorType, indicatorIndex) => {
                                return (
                                    <tr className="table-row">
                                        <th>{indicatorType.lable}</th>
                                        <td className={'alert ' + indicatorType.class} ></td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

AlertsLegend.contextTypes = {
    t: PropTypes.func.isRequired
}

export default AlertsLegend;
